import { SuperAdminService } from "services/superAdminService";

class DuasSAService extends SuperAdminService<any> {
  constructor() {
    super("duas");
  }
}
export default new DuasSAService();
